export default __webpack_public_path__ + "static/media/sh2_1.a70a56bd.jpg";